import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import "./live-analog-page.scss";

const guestImage =
  "https://cdn.datongbei.com/icdesign-17915306618999dbg7a6e8fge4.png";

function LiveAnalogPage() {
  const [reservationVisible, setReservationVisible] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "通用智能体驱动的数模混合芯片设计｜icdesign 特邀直播";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="live-analog-page">
      <main id="top">
        <section className="hero" aria-labelledby="heroTitle">
          <div className="container hero-inner">
            <div className="hero-copy">
              <div className="eyebrow">
                <span className="live-dot" aria-hidden="true"></span>icdesign
                特邀直播 · 2026
              </div>
              <h1 id="heroTitle">
                通用智能体驱动的<span className="accent">数模混合芯片设计</span>
              </h1>
              <p className="hero-lead">
                从真实的芯片设计任务出发，分享通用智能体在电路设计、仿真验证与迭代优化中的实践，以及工程落地的经验与局限。
              </p>
              <div
                className="event-date"
                aria-label="预计直播时间：2026 年 11 月上旬"
              >
                <span>直播时间 · 预计</span>
                <strong>
                  2026 年 <b>11 月上旬</b>
                </strong>
              </div>
              <div className="hero-meta" aria-label="直播信息">
                <span className="meta-pill">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M5 7h10v10H5zM15 10l4-2v8l-4-2"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinejoin="round"
                    />
                  </svg>
                  icdesign.com 在线直播
                </span>
                <span className="meta-pill">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <circle
                      cx="12"
                      cy="8"
                      r="4"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <path
                      d="M4.5 21a7.5 7.5 0 0 1 15 0"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                  </svg>
                  特邀嘉宾 · 张托肯
                </span>
              </div>
              <div className="hero-actions">
                <button
                  className="button button-primary"
                  type="button"
                  onClick={() => setReservationVisible(true)}
                  aria-haspopup="dialog"
                >
                  免费预约
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="m9 18 6-6-6-6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <p className="hero-note">
                具体日期、开播时间及预约安排，以 icdesign 后续通知为准。
              </p>
            </div>

            <div className="hero-visual" aria-label="嘉宾张托肯">
              <div className="portrait-anchor">
                <div className="portrait-frame">
                  <img src={guestImage} alt="张托肯（张智帅博士）" />
                  <div className="portrait-caption">
                    <div>
                      <strong>张托肯</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="section agenda-section"
          id="agenda"
          aria-labelledby="agendaTitle"
        >
          <div className="container">
            <div className="section-heading">
              <h2 id="agendaTitle">本场内容</h2>
              <p>
                面向模拟与混合信号设计工程师、芯片设计研究者，以及希望尝试智能体工具的同学。
              </p>
            </div>
            <div className="agenda-list">
              <article className="agenda-item">
                <span className="agenda-no" aria-hidden="true">
                  01 /
                </span>
                <h3>路线：先进 AI 如何进入芯片设计？</h3>
                <p>
                  从“通用模型 + 通用智能体 +
                  场景化能力”出发，介绍工具接入、流程约束与结果验证的方法。
                </p>
              </article>
              <article className="agenda-item">
                <span className="agenda-no" aria-hidden="true">
                  02 /
                </span>
                <h3>实战：Agent 已经跑通哪些流程？</h3>
                <p>
                  结合 22nm 数模混合芯片、28nm 数字芯片，以及 Virtuoso
                  Bridge、ADCToolbox，分享设计、测试与建模实践。
                </p>
              </article>
              <article className="agenda-item">
                <span className="agenda-no" aria-hidden="true">
                  03 /
                </span>
                <h3>展望：芯片设计如何迎接新常态？</h3>
                <p>
                  讨论智能体的能力边界，以及基准测试、电路数据和算力如何推动更可靠的设计实践。
                </p>
              </article>
            </div>
          </div>
        </section>

        <section
          className="section guest-section"
          id="guest"
          aria-labelledby="guestTitle"
        >
          <div className="container guest-layout">
            <div className="guest-heading">
              <h2 id="guestTitle">嘉宾简介</h2>
              <div className="guest-name">
                <strong>张智帅</strong>
                <span>张托肯 · Token Zhang</span>
              </div>
            </div>
            <div className="guest-copy">
              <p className="guest-bio">
                张智帅，现于瑞士苏黎世联邦理工学院（ETH
                Zurich）的集成系统实验室与人工智能中心从事博士后研究。曾任
                MiniMax 10x Fellowship 研究员。分别于 2021 年和 2026
                年获得清华大学电子工程系学士和博士学位。曾获 IEEE Solid-State
                Circuits Society 学生电路设计竞赛奖、ISSCC Jack Kilby
                Outstanding Student Paper Award、ISSCC Student Travel Grant
                Award
                等国际奖项，并获国家自然科学基金青年学生基础研究项目（博士研究生）等资助与荣誉。
              </p>
              <div className="profile-links">
                <a
                  className="text-link"
                  href="https://www.tokenzhang.com/zh/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  个人主页：tokenzhang.com ↗
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Modal
        className="live-reservation-modal"
        title="扫码加入直播交流群"
        visible={reservationVisible}
        onCancel={() => setReservationVisible(false)}
        footer={null}
        width={420}
        centered
      >
        <p className="live-reservation-description">
          欢迎加入微信群，了解本场直播安排、获取开播通知，与大家一起交流芯片设计与 AI 实践。
        </p>
        <img
          className="live-reservation-qr"
          src="https://cdn.datongbei.com/icdesign-1793516333079hgf85g20925c3.jpg"
          alt="直播交流微信群二维码，请使用微信扫码加入"
          width="526"
          height="532"
        />
        <p className="live-reservation-hint">
          使用微信扫一扫，或保存二维码后在微信中识别
        </p>
      </Modal>
      <footer className="site-footer">
        <div className="container footer-inner">
          <span>
            © icdesign 2026{" "}
            <a href="https://beian.miit.gov.cn/">
              <span>沪ICP备2021031452号</span>
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default LiveAnalogPage;
